<template>
    <v-row class="ma-0 pa-0">
        <v-col md="2" sm="12" cols="12" v-if="SessionId">
            <Sidebar :SessionId="SessionId"></Sidebar>
        </v-col>
        <v-col md="10" sm="12">
            <h1 class="headline">
                Archived Registers
            </h1>
            <v-btn icon depressed x-small style="vertical-align:top;" rel="noopener" :href="'/api/Documents/DocumentTypesRSS?Type=50'" aria-label="Add the archived registers to your rss feed">
                <img src="../Content/images/social_style_3_rss-512-1.png"
                     alt="Add the archived registers to your rss feed"
                     title="Add the archived registers to your rss feed"
                     aria-hidden="true"
                     style="height:24px; width:24px;" />
            </v-btn>
            <!--<v-btn depressed x-small color="orange" style="vertical-align:top;" rel="noopener" :href="'/api/Documents/DocumentTypesRSS?Type=50'">
                <span class="white--text">RSS</span><v-icon color="white" right>{{rss}}</v-icon>
            </v-btn>-->
            <v-container>
                <v-layout row wrap>
                    <GoogleSearch></GoogleSearch>
                </v-layout>
            </v-container>
            <v-divider></v-divider>

            <v-layout row wrap>
                <v-card flat>
                    <v-card-title>
                        <v-autocomplete v-model="Volume"
                                        style="max-width:300px"
                                        :items="Volumes"
                                        item-value="name"
                                        item-text="value"
                                        aria-label="Register"></v-autocomplete> Register
                    </v-card-title>
                    <v-card-text>
                        <v-progress-linear indeterminate
                                           v-if="loading"
                                           color="primary" aria-label="Loading"></v-progress-linear>
                        <div>
                            The South Dakota Register is a weekly publication that contains: notices of hearings on proposed amendments to administrative rules; final administrative rules filed in the secretary of state's office; executive orders; judicial, legislative and executive appointments; declaratory rulings; and other information which is not otherwise generally available to the public. You may receive copies electronically by e-subscribing using MyLRC.
                        </div>
                        <span v-if="Documents && Documents.length == 0">
                            <v-alert v-if="!loading" dense
                                     text
                                     type="info">No registers available for this year.</v-alert>
                        </span>
                        <!--<v-container>
                    <v-layout row wrap>
                        <v-flex xs12 sm2 md3 v-for="d in Documents" :key="d.DocumentId">
                            <a rel="noopener" :href="$MyLRCUrl.value + 'api/Documents/Register/' + d.DocumentId + '.pdf'">{{DatePretty(d.DocumentDate)}}</a>
                        </v-flex>
                    </v-layout>
                </v-container>-->
                        <div style="flex: 1; overflow: auto;">
                            <FilterableDataTable :headers="headers"
                                                 disable-pagination
                                                 hide-default-footer
                                                 item-value="DocumentId"
                                                 sort-by="DocumentDate"
                                                 :sort-desc="true"
                                                 :items="Documents">
                                <template v-slot:item.DocumentDate="{ item }">
                                    <a target="_blank" rel="noopener noreferrer" :href="$MyLRCUrl.value + 'api/Documents/Register/' + item.DocumentId + '.pdf'">{{DatePretty(item.DocumentDate)}}</a>
                                </template>
                                <template v-slot:item.VolumnNumber="{ item }">
                                    {{item.VolumnNumber}}
                                </template>
                                <template v-slot:item.Pages="{item}">
                                    {{item.StartPageNumber}} - {{item.LastPageNumber}}
                                </template>
                            </FilterableDataTable>
                        </div>
                    </v-card-text>
                </v-card>
            </v-layout>
        </v-col>
    </v-row>

</template>
<script>
    const FilterableDataTable = () => import("@/Components/FilterableDataTable.vue");
    import moment from 'moment'
    import { mdiRss } from '@mdi/js';
    const Sidebar = () => import("@/Menus/Sidebar.vue");
    const GoogleSearch = () => import("@/Components/GoogleSearch.vue");
    export default {
        name: 'Registers',
        props: ['SessionId'],
        components: { Sidebar, GoogleSearch, FilterableDataTable },
        methods: {
            LoadData() {
                if (this.SessionId) {
                    fetch('/api/Sessions/' + this.SessionId, {
                        method: "GET",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json"
                        },
                    }).then(res => {
                        this.loading = false;
                        if (res.status === 200 || res.status === 201) {
                            return res.json();
                        }
                        else {
                            return null;
                        }
                        throw new Error(res.statusText);
                    }).then(response => {
                        this.Session = EncodeDatetimes(response);
                    }).catch(error => {
                        throw new Error(error);
                    });
                }
                else {
                    fetch('/api/Sessions/Current', {
                        method: "GET",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json"
                        },
                    }).then(res => {
                        this.loading = false;
                        if (res.status === 200 || res.status === 201) {
                            return res.json();
                        }
                        else {
                            return null;
                        }
                        throw new Error(res.statusText);
                    }).then(response => {
                        this.Session = EncodeDatetimes(response);
                    }).catch(error => {
                        throw new Error(error);
                    });
                }
                fetch('/api/Documents/DocumentType?Type=50', {
                    method: "GET",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/json"
                    },
                }).then(res => {
                    this.loading = false;
                    if (res.status === 200 || res.status === 201) {
                        return res.json();
                    }
                    else {
                        return null;
                    }
                    throw new Error(res.statusText);
                }).then(response => {
                    this.items = [];
                    this.items = EncodeDatetimes(response);
                    if (this.Session) {
                        this.Year = this.Session.Year;
                    }
                    else if (this.Session && this.Session.SessionId) {
                        this.Year = new Date().Year;
                        this.$router.push('/Rules/Registers/' + this.Session.SessionId);
                    }
                    else {
                        this.Year = "2022";
                        this.$router.push('/Rules/Registers/64');
                    }

                    this.Volume = Math.max(...this.items.map(a => a.VolumnNumber));

                    this.loading = false;
                }).catch(error => {
                    throw new Error(error);
                });
            },
            DatePretty(date) {
                return moment(date, "DD/MM/YYYY").format("M/DD/YYYY");
            },
            GetPages(Start, End) {
                var l = '';
                for (var i = Start; i <= End; i++) {
                    l = l + ', ' + i;
                }

                return l.substring(2);
            }
        },
        data: function () {
            return {
                rss: mdiRss,
                loading: true,
                items: [],
                allDocuments: [],
                Year: null,
                Volume: null,
                Session: {},
                headers: [
                    { text: 'Document Date', value: 'DocumentDate', width: '25ch' },
                    { text: 'Volume', value: 'VolumnNumber', width: '25ch' },
                    { text: 'Pages', value: 'Pages', key: 'Pages', width: '*' },
                ],
            }
        },
        mounted: function () {
            this.LoadData();
        },
        watch: {
            SessionId: {
                handler() {
                    this.Year = null;
                    this.LoadData();
                },
            },
        },
        computed: {
            Documents: function () {
                //if (this.Year) {
                //    var d = this.items.filter(x => moment(x.DocumentDate, "DD/MM/YYYY").format("YYYY") == this.Year).reverse();
                //    d.forEach(o => o.Pages = (o.StartPageNumber + " - " + o.LastPageNumber));
                //    return d;
                //}
                //else {
                //    return [];
                //}
                if (this.Volume) {
                    var d = this.items.filter(x => x.VolumnNumber == this.Volume).reverse();
                    d.forEach(o => o.Pages = (this.GetPages(o.StartPageNumber, o.LastPageNumber)));
                    return d;
                }
                else {
                    return [];
                }
            },
            Years: function () {
                let docDates = this.items.map(a => moment(a.DocumentDate, "DD/MM/YYYY").format("YYYY"));
                if (docDates && docDates.length > 0 && this.Session && this.Session.Year) {
                    var unique = [...new Set(docDates)].sort().reverse();
                    if (!unique.find(x => x == this.Session.Year)) {
                        unique.push(this.Session.Year);
                    }
                    return unique;
                } else {
                    return [];
                }
            },
            Volumes: function () {
                if (!this.items) {
                    return [];
                }
                let docVolumes = this.items.filter(a => a.VolumnNumber != null).map(a => a.VolumnNumber);
                if (docVolumes && docVolumes.length > 0) {
                    var unique = [...new Set(docVolumes)].sort().reverse();
                    var result = unique.map(d => ({ name: d, value: null }));
                    result.forEach(o => o.value = "Volume: " + o.name + " (" +
                        moment(new Date(Math.min(...this.items.filter(a => a.VolumnNumber == o.name).map(a => a.DocumentDate))), "DD/MM/YYYY").format("MMM YYYY") +
                        " - " + moment(new Date(Math.max(...this.items.filter(a => a.VolumnNumber == o.name).map(a => a.DocumentDate))), "DD/MM/YYYY").format("MMM YYYY") + ")");

                    return result;
                } else {
                    return [];
                }
            },
            Title: function () {
                let title = 'Archived Registers';
                return title;
            },
            Description: function () {
                return this.Title;
            }
        },
        metaInfo() {
            return {
                title: this.Title,
                meta: [
                    { vmid: 'description', name: 'description', content: this.Description },
                    // OpenGraph data (Most widely used)
                    { vmid: 'og:title', property: 'og:title', content: this.Title + ' | South Dakota Legislature' },
                    // The list of types is available here: http://ogp.me/#types
                    { vmid: 'og:type', property: 'og:type', content: 'website' },
                    // Should be the same as your canonical link, see below.
                    { vmid: 'og:url', property: 'og:url', content: window.location.href },
                    // Often the same as your meta description, but not always.
                    { vmid: 'og:description', property: 'og:description', content: this.Description },

                    // Twitter card
                    { vmid: 'twitter:card', name: 'twitter:card', content: 'summary' },
                    { vmid: 'twitter:site', name: 'twitter:site', content: window.location.href },
                    { vmid: 'twitter:title', name: 'twitter:title', content: this.Title + ' | South Dakota Legislature' },
                    { vmid: 'twitter:description', name: 'twitter:description', content: this.Description }
                ],
                link: [
                    { vmid: 'canonical', rel: 'canonical', href: window.location.href.split('?')[0] }
                ]
            }
        }
    };
</script>
<style></style>